import { createContext, useState, ReactNode, Dispatch, SetStateAction } from "react";
import { GlobalSettings } from "../services/interfaces";
import { config } from "@fortawesome/fontawesome-svg-core";

interface User {
    loggedIn: boolean;
    username: string;
    type: number;
    email: string;
    phone:string;
    fax:string;
    customer:string;
    siteCode: string;
    fullName:string;
    trusted:boolean;
    superUser:boolean;
    trafficUser:boolean;
    apiKey:string;
}

interface UserContextType {
    user: User;
    updateUser: (newUser: User) => void;
}

export const UserContext = createContext<UserContextType | null>(null);

interface UserContextProviderProps {
    children: ReactNode;
}

export function UserContextProvider({children}: UserContextProviderProps){
    const [user, setUser] = useState(
        {
            loggedIn:false,
            username:'',
            type:0,
            email:'',
            phone:'',
            fax:'',
            customer:'',
            siteCode:'',
            fullName:'',
            trusted:true,
            superUser:false,
            trafficUser:false,
            apiKey:""
        }
    );

    const updateUser = (newUser: User) => {
        setUser(newUser);
    }

    return (
        <UserContext.Provider value={{user,updateUser}}>
            {children}
        </UserContext.Provider>
    );
}